var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 15.5833 3.66667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 1.83333C3.66667 2.84586 2.84586 3.66667 1.83333 3.66667C0.820811 3.66667 0 2.84586 0 1.83333C0 0.820811 0.820811 0 1.83333 0C2.84586 0 3.66667 0.820811 3.66667 1.83333Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 1.83333C9.625 2.84586 8.80419 3.66667 7.79167 3.66667C6.77914 3.66667 5.95833 2.84586 5.95833 1.83333C5.95833 0.820811 6.77914 0 7.79167 0C8.80419 0 9.625 0.820811 9.625 1.83333Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 1.83333C15.5833 2.84586 14.7625 3.66667 13.75 3.66667C12.7375 3.66667 11.9167 2.84586 11.9167 1.83333C11.9167 0.820811 12.7375 0 13.75 0C14.7625 0 15.5833 0.820811 15.5833 1.83333Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverflow);
export default __webpack_public_path__ + "static/media/overflow.5138d4267c68012f578dc3b97e427e72.svg";
export { ForwardRef as ReactComponent };